'use strict';

module.exports = {};

// Athom Cloud
module.exports.AthomAppsAPI = require('./lib/AthomAppsAPI');
module.exports.AthomBackupAPI = require('./lib/AthomBackupAPI');
module.exports.AthomCallbackAPI = require('./lib/AthomCallbackAPI');
module.exports.AthomCloudAPI = require('./lib/AthomCloudAPI');
module.exports.AthomConnectAPI = require('./lib/AthomConnectAPI');
module.exports.AthomDNSAPI = require('./lib/AthomDNSAPI');
module.exports.AthomFirmwareAPI = require('./lib/AthomFirmwareAPI');
module.exports.AthomFlowAPI = require('./lib/AthomFlowAPI');
module.exports.AthomGeolocateAPI = require('./lib/AthomGeolocateAPI');
module.exports.AthomIconsAPI = require('./lib/AthomIconsAPI');
module.exports.AthomInfraredAPI = require('./lib/AthomInfraredAPI');
module.exports.AthomNotificationsAPI = require('./lib/AthomNotificationsAPI');
module.exports.AthomSetupAPI = require('./lib/AthomSetupAPI');
module.exports.AthomStoreAPI = require('./lib/AthomStoreAPI');
module.exports.AthomWeatherAPI = require('./lib/AthomWeatherAPI');
module.exports.AthomWebhooksAPI = require('./lib/AthomWebhooksAPI');

// Homey Cloud
module.exports.HomeyCloudAPI = require('./lib/HomeyCloudAPI');

// Homey API
module.exports.HomeyAPI = require('./lib/HomeyAPI/HomeyAPI');
module.exports.HomeyAPIV1 = require('./lib/HomeyAPI/HomeyAPIV1');
module.exports.HomeyAPIV2 = require('./lib/HomeyAPI/HomeyAPIV2');
module.exports.HomeyAPIV3 = require('./lib/HomeyAPI/HomeyAPIV3');
module.exports.HomeyAPIV3Local = require('./lib/HomeyAPI/HomeyAPIV3Local');
module.exports.HomeyAPIV3Cloud = require('./lib/HomeyAPI/HomeyAPIV3Cloud');

// APIError
module.exports.APIError = require('./lib/APIError');
module.exports.APIErrorHomeyOffline = require('./lib/APIErrorHomeyOffline');
module.exports.APIErrorNotFound = require('./lib/APIErrorNotFound');
module.exports.APIErrorTimeout = require('./lib/APIErrorTimeout');

// Util
module.exports.Util = require('./lib/Util');
